import { render, staticRenderFns } from "./masterCourier.vue?vue&type=template&id=c709b486&"
import script from "./masterCourier.vue?vue&type=script&lang=js&"
export * from "./masterCourier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports